module.exports = __webpack_public_path__ + "img/zaeune.30396a75.webp";